// fetch
import fetch from 'isomorphic-fetch'
import sha1 from 'sha1'

import * as types from '../constants/ActionTypes'
import { findRouteIndex } from '../constants/routes'
import isDisponibile from '../utils/disponibilitaUtils'
import { getSentryTransactionForActions } from '../utils/sentryUtils'

/** ******************
 // USE BATCHED-ACTIONS

 ******************* */

// WARNING: if you need a full-featured creator, import redux-actions
export const createBasicCreator = actionType => payload => ({
  type: actionType,
  payload,
})

// this is a crappy implementation
export const fetchData = actionType => payload => (dispatch, getState) => {
  if (!payload.fetchingDisabled) {
    dispatch(
      fetching({
        fetching: true,
      })
    )
  }

  const suppressErrorNotice = !!payload.suppressErrorNotice
  const suppressOnlyErrorNotice = !!payload.suppressOnlyErrorNotice
  const { uri } = payload

  let headers_array = {}
  if (!payload.disableJsonSerialization) {
    headers_array = { 'Content-Type': 'application/json' }
  }

  const token = payload.token ? payload.token : getState().customer.token

  if (payload.token || uri.indexOf('/t/') !== -1) {
    headers_array.Authorization = `Bearer ${token}`
  }

  const brum_session_id = getState().uuid
  headers_array['X-Brum-Session-Id'] = brum_session_id

  const sentryNewTransaction = getSentryTransactionForActions(
    actionType,
    payload
  )
  headers_array['sentry-trace'] = sentryNewTransaction.traceId

  const headers = new Headers(headers_array)

  const fetch_options = {
    headers,
    method: payload.method,
  }

  if (payload.body && !payload.disableJsonSerialization) {
    fetch_options.body =
      typeof payload.body === 'string'
        ? payload.body
        : JSON.stringify(payload.body)
  } else {
    fetch_options.body = payload.body
  }

  return new Promise((resolve, reject) => {
    fetch(uri, fetch_options)
      .then(response => {
        /**
         * fatto cosi seguendo l'esempio
         * https://github.com/reactjs/redux/blob/master/examples/real-world/src/middleware/api.js#L26
         */
        // utilizzato in alternativa ad xray
        // se quest'ultimo non presente
        const selloutCallHash = brum_session_id
        // estraggo l'header xray di risposta
        const responseHeaders = response.headers
        const XrayHeader = responseHeaders.get('x-amzn-trace-id')
        const XrayRoot =
          XrayHeader && XrayHeader.split ? XrayHeader.split(';Root=') : null
        // Self=1-5da03811-c30abcb8804ddef8df078b98;Root=1-5759e988-bd862e3fe1be46a994272793;Parent=53995c3f42cd8ad8;Sampled=1
        const XrayRootId =
          XrayRoot && XrayRoot.length >= 1 ? XrayRoot[1].split(';')[0] : null

        const response_details = {
          jsonEx: null,
          body_text: null,
          body_json: null,
          status: response.status,
          text: response.statusText,
          url: response.url,
          xray: XrayRootId,
          selloutCallHash,
          brum_session_id: selloutCallHash,
          type: 'generic',
          suppressOnlyErrorNotice,
        }

        response
          .text()
          .then(text => {
            const isEmptyBody =
              response.status === 304 || response.status === 204
            let json = false
            let jsonEx = false
            try {
              json = JSON.parse(
                isEmptyBody
                  ? '{"result":null, "message": "304 o 204, empty body from action/Buy.js", "code": 999}'
                  : text
              )
            } catch (ex) {
              jsonEx = ex
            }

            response_details.jsonEx = jsonEx
            response_details.body_text = text
            response_details.body_json = json

            if (response.status >= 200 && response.status < 400) {
              if (json === false) {
                const derivedErrorType = `${actionType}_HTTP_${response.status}_JSON_ERROR`
                sentryNewTransaction.setHttpStatus(520)
                sentryNewTransaction.setTag(
                  'derivedErrorType',
                  derivedErrorType
                )
                sentryNewTransaction.finish()
                if (!suppressErrorNotice) {
                  response_details.type = derivedErrorType
                  dispatch(errorNotice(response_details))
                }
                dispatch(
                  fetching({
                    fetching: false,
                  })
                )
                reject(jsonEx)
              } else if (payload.callback === actionType) {
                sentryNewTransaction.setHttpStatus(response.status)
                sentryNewTransaction.finish()
                /**
                 * BRUM-4010
                 * se callback e actionType sono uguali
                 * significa che si vuole usare nel reducer
                 * lo stesso identificativo utilizzato per
                 * eseguire la fetch
                 */
                dispatch(
                  createBasicCreator(actionType)({
                    data: json,
                    response_details,
                    payload,
                  })
                )
              } else if (payload.callback) {
                sentryNewTransaction.setHttpStatus(response.status)
                sentryNewTransaction.finish()
                dispatch(
                  payload.callback({
                    data: json,
                    response_details,
                    payload,
                  })
                )
              }
              return json
            }
            const errorCodeForErrorType =
              json === false ? '_JSON_ERROR' : `_BCODE_${json.code}`
            const derivedErrorType = `${actionType}_HTTP_${response.status}${errorCodeForErrorType}`
            response_details.type = payload.error_400
              ? payload.error_400
              : derivedErrorType
            sentryNewTransaction.setTag('derivedErrorType', derivedErrorType)
            sentryNewTransaction.setHttpStatus(response.status)
            sentryNewTransaction.finish()
            if (!suppressErrorNotice) {
              dispatch(errorNotice(response_details))
            }
            dispatch(fetching({ fetching: false }))
            // dispatch(postSlack(response_details))
            reject(response_details)
          })
          .then(json => {
            dispatch(
              fetching({
                fetching: false,
              })
            )
            return json
          })
          .then(json => {
            resolve(json)
          })
          .catch(ex => {
            reject(ex)
          })
      })
      .catch(ex => {
        const response_details = {
          status: `${ex}`,
          text: 'ERRORE DI RETE O TIMEOUT SERVIZI BRUMBRUM',
          url: uri,
          location: window.location.href,
          xray: sha1(Math.random() + new Date().getTime() + uri).substring(
            0,
            7
          ),
          type: 'errore_connessione',
          suppressOnlyErrorNotice,
        }
        sentryNewTransaction.setTag('derivedErrorType', `${ex}`)
        sentryNewTransaction.setHttpStatus(420)
        sentryNewTransaction.finish()
        if (!suppressErrorNotice) {
          dispatch(errorNotice(response_details))
        }
        dispatch(
          fetching({
            fetching: false,
          })
        )
        // dispatch( postSlack( response_details ) )
        reject(ex)
      })
  })
}

// global ui
export const ERROR_NOTICE = 'ERROR_NOTICE'
export const errorNotice = createBasicCreator(ERROR_NOTICE)

export const FETCHING = 'FETCHING'
export const fetching = createBasicCreator(FETCHING)

export const GET_PAGE_SETTINGS = 'GET_PAGE_SETTINGS'
export const getPageSettings = fetchData(GET_PAGE_SETTINGS)
export const SET_PAGE_SETTINGS = 'SET_PAGE_SETTINGS'
export const setPageSettings = createBasicCreator(SET_PAGE_SETTINGS)

export const REROUTE = 'REROUTE'

function getVRef() {
  if (window.location.pathname.indexOf('acquista') > 0) {
    return 'v=sellout-acquisto-refreshed'
  }

  if (window.location.pathname.indexOf('noleggia') > 0) {
    return 'v=sellout-noleggio-refreshed'
  }

  return ''
}

function getCreateOrdineRouteIndex() {
  if (window.location.pathname.indexOf('acquista') > 0) {
    return findRouteIndex('/cart')
  }

  if (window.location.pathname.indexOf('noleggia') > 0) {
    return findRouteIndex('/scegli-canone')
  }

  return -1
}

const rerouteAndDisponibilitaCheck = () => payload => (dispatch, getState) => {
  const currentIdOrdine = getState().ordine.id_ordine

  const _fetchData = fetchData(types.REROUTE_CHECK_DISPONIBILITA)

  const { token } = getState().customer
  const { product } = getState()

  const idAuto = RegExp('B[A-Z]\\d{6}').exec(window.location.pathname)[0]

  if (payload === '/cart') {
    /**
     * se stiamo facendo reroute a cart
     * non c'e' bisogno di fare altri
     * controlli
     */
    return new Promise(resolve => {
      if (payload) {
        dispatch(createBasicCreator(REROUTE)(payload))
      }
      resolve()
    })
  }

  if (!token) {
    // controlliamo dove siamo
    // se siamo a meta' di un processo inviamo su recupera ordine
    const currentRouteFromUrl = RegExp('#([\\/\\w-]+)').exec(
      window.location.hash
    )[1]
    const routeIndex = findRouteIndex(currentRouteFromUrl)
    const createOrdineRouteIndex = getCreateOrdineRouteIndex()
    if (routeIndex > createOrdineRouteIndex) {
      // l'utente era a meta' di un processo
      // ed ha fatto aggiorna pagina
      const redirectTo = `/recupero-ordine/${idAuto}?${getVRef()}`
      window.location.href = redirectTo

      return new Promise(resolve => resolve())
    }
  }

  return new Promise((resolve, reject) => {
    dispatch(
      _fetchData({
        method: currentIdOrdine ? 'GET' : 'POST',
        uri: currentIdOrdine
          ? `${window.brumbrum.url_api}/ordini/t/v1/ordini/${currentIdOrdine}`
          : `${window.brumbrum.url_api}/cms/p/v4/auto/${idAuto}`,
      })
    )
      .then(json => {
        const blockedIdOrdine = currentIdOrdine
          ? json.result.stato_attuale_auto.id_ordine
          : json.result.id_ordine

        const ordini_prezzo_sellout_base = currentIdOrdine
          ? json.result.auto_prezzo_sellout_base
          : null
        const auto_prezzo_sellout = currentIdOrdine
          ? json.result.stato_attuale_auto.prezzo_sellout
          : null

        if (
          ordini_prezzo_sellout_base !== auto_prezzo_sellout &&
          product.linea_prodotto !== 'NLT_ARVAL' &&
          product.linea_prodotto !== 'NLT_BRUMBRUM'
        ) {
          dispatch(
            errorNotice({
              // Prezzo non aggiornatoo
              // L'auto ha subito una variazione di prezzo, crea un nuovo ordine o contatta il servizio clienti
              type: 'custom',
              message:
                "L'auto ha subito una variazione di prezzo, crea un nuovo ordine o contatta il servizio clienti",
              title: 'Prezzo non aggiornato',
              linkText: 'Torna alla pagina prodotto',
              linkHref: `/${product.id_auto}`,
              logo: 'auto_non_disponibile',
            })
          )
          reject(json)
        } else if (isDisponibile(product)) {
          if (payload) {
            dispatch(createBasicCreator(REROUTE)(payload))
          }
          resolve(json)
        } else if (
          !!blockedIdOrdine &&
          `${currentIdOrdine}` !== `${blockedIdOrdine}`
        ) {
          dispatch(
            errorNotice({
              type: 'auto_non_disponibile',
            })
          )
          reject(json)
        } else {
          if (payload) {
            dispatch(createBasicCreator(REROUTE)(payload))
          }
          resolve(json)
        }
      })
      .catch(ex => {
        reject(ex)
      })
  })
}
export const reroute = rerouteAndDisponibilitaCheck()

export const PHASECHANGE = 'PHASECHANGE'
export const phaseChange = createBasicCreator(PHASECHANGE)

export const BUYHELPER = 'BUYHELPER'
export const buyHelper = createBasicCreator(BUYHELPER)

export const BUYHELP_DOCUMENTI = 'BUYHELP_DOCUMENTI'
export const toggleHelpDocumenti = createBasicCreator(BUYHELP_DOCUMENTI)

// authentication
export const CUSTOMER_TOKEN = 'CUSTOMER_TOKEN'
export const customerToken = fetchData(CUSTOMER_TOKEN)

export const CUSTOMER_TOKEN_CALLBACK = 'CUSTOMER_TOKEN_CALLBACK'
export const customerTokenCallback = createBasicCreator(CUSTOMER_TOKEN_CALLBACK)

// user
export const CUSTOMER_UPDATE = 'CUSTOMER_UPDATE'
export const customerUpdate = createBasicCreator(CUSTOMER_UPDATE)

// pricing
export const PRICING_UPDATE = 'PRICING_UPDATE'
export const pricingUpdate = createBasicCreator(PRICING_UPDATE)

// privacy - brumbrum
export const PRIVACY_UPDATE = 'PRIVACY_UPDATE'
export const privacyUpdate = createBasicCreator(PRIVACY_UPDATE)

// privacy - financements
export const ACCEPTANCE_UPDATE = 'ACCEPTANCE_UPDATE'
export const acceptanceUpdate = createBasicCreator(ACCEPTANCE_UPDATE)

// product page
export const GET_PRODUCT_DETAILS = 'GET_PRODUCT_DETAILS'
export const getProductDetails = fetchData(GET_PRODUCT_DETAILS)

export const NEW_PRODUCT_DETAILS = 'NEW_PRODUCT_DETAILS'
export const newProductDetails = createBasicCreator(NEW_PRODUCT_DETAILS)

// calcolatrice
export const GET_DEFAULT_FINANCEMENTS = 'GET_DEFAULT_FINANCEMENTS'
export const getDefaultFinancements = fetchData(GET_DEFAULT_FINANCEMENTS)

// get financement details by id_finanziamento
export const GET_FINANCEMENT_DETAILS = 'GET_FINANCEMENT_DETAILS'
export const getFinancementDetails = fetchData(GET_FINANCEMENT_DETAILS)

export const NEW_DEFAULT_FINANCEMENTS = 'NEW_DEFAULT_FINANCEMENTS'
export const NEW_DEFAULT_FINANCEMENTS_V4 = 'NEW_DEFAULT_FINANCEMENTS_V4'
export const NEW_DEFAULT_FINANCEMENTS_FINDOMESTIC =
  'NEW_DEFAULT_FINANCEMENTS_FINDOMESTIC'
export const newDefaultFinancements = createBasicCreator(
  NEW_DEFAULT_FINANCEMENTS
)
export const newDefaultFinancementsv4 = createBasicCreator(
  NEW_DEFAULT_FINANCEMENTS_V4
)
export const newDefaultFinancementsFindomestic = createBasicCreator(
  NEW_DEFAULT_FINANCEMENTS_FINDOMESTIC
)

export const GET_COMUNI = 'GET_COMUNI'
export const getComuni = fetchData(GET_COMUNI)

export const NEW_COMUNI = 'NEW_COMUNI'
export const newComuni = createBasicCreator(NEW_COMUNI)

export const GET_NAZIONI = 'GET_NAZIONI'
export const getNazioni = fetchData(GET_NAZIONI)

export const NEW_NAZIONI = 'NEW_NAZIONI'
export const newNazioni = createBasicCreator(NEW_NAZIONI)

export const POST_NEW_ORDINE = 'POST_NEW_ORDINE'
export const postNewOrdine = fetchData(POST_NEW_ORDINE)

export const newOrdine = createBasicCreator(types.NEW_ORDINE)

export const GET_ORDINE = 'GET_ORDINE'
export const getOrdine = fetchData(GET_ORDINE)

export const PAYMENT_METHOD_SELECTED = 'PAYMENT_METHOD_SELECTED'
export const paymentMethodSelected = createBasicCreator(PAYMENT_METHOD_SELECTED)

export const POST_FINANZIAMENTO_SELECTED = 'POST_FINANZIAMENTO_SELECTED'
export const postFinanziamentoSelected = fetchData(POST_FINANZIAMENTO_SELECTED)

export const POST_BONIFICO_SELECTED = 'POST_BONIFICO_SELECTED'
export const postBonificoSelected = fetchData(POST_BONIFICO_SELECTED)

export const FINANZIAMENTO_SELECTED = 'FINANZIAMENTO_SELECTED'
export const finanziamentoSelected = createBasicCreator(FINANZIAMENTO_SELECTED)

export const POST_SECCI = 'POST_SECCI'
export const postSecci = fetchData(POST_SECCI)

export const NEW_SECCI = 'NEW_SECCI'
export const newSecci = createBasicCreator(NEW_SECCI)

export const ACCEPT_SECCI = 'ACCEPT_SECCI'
export const acceptSecci = fetchData(ACCEPT_SECCI)

export const COMPASS_UPDATE = 'COMPASS_UPDATE'
export const compassUpdate = createBasicCreator(COMPASS_UPDATE)

export const PUT_COMPASS = 'PUT_COMPASS'
export const putCompass = fetchData(PUT_COMPASS)

export const PUT_COMPASS_CALLBACK = 'PUT_COMPASS_CALLBACK'
export const putComapassCallback = createBasicCreator(PUT_COMPASS_CALLBACK)

export const PUT_TRACCIATO = 'PUT_TRACCIATO'
export const putTracciato = fetchData(PUT_TRACCIATO)

export const PUT_TRACCIATO_CALLBACK = 'PUT_TRACCIATO_CALLBACK'
export const putTracciatoCallback = createBasicCreator(PUT_TRACCIATO_CALLBACK)

export const POST_COMPASS_CONGRATS = 'POST_COMPASS_CONGRATS'
export const postCompassCongrats = fetchData(POST_COMPASS_CONGRATS)

export const UPDATE_SECCI = 'UPDATE_SECCI'
export const updateSecci = createBasicCreator(UPDATE_SECCI)

export const UPDATE_ORDINE = 'UPDATE_ORDINE'
export const updateOrdine = createBasicCreator(UPDATE_ORDINE)

export const UPDATE_FINANCEMENTS = 'UPDATE_FINANCEMENTS'
export const updateFinancements = createBasicCreator(UPDATE_FINANCEMENTS)

export const POST_COMPASS_CUSTOM_CALC = 'POST_COMPASS_CUSTOM_CALC'
export const postCompassCustomCalc = fetchData(POST_COMPASS_CUSTOM_CALC)

export const UPDATE_FINANCEMENTS_COMPASS_CUSTOM_CALC =
  'UPDATE_FINANCEMENTS_COMPASS_CUSTOM_CALC'
export const updateFinancementsCompassCustomCalc = createBasicCreator(
  UPDATE_FINANCEMENTS_COMPASS_CUSTOM_CALC
)

export const UPDATE_FINANCEMENTS_FINDOMESTIC_CUSTOM_CALC =
  'UPDATE_FINANCEMENTS_FINDOMESTIC_CUSTOM_CALC'
export const updateFinancementsFindomesticCustomCalc = createBasicCreator(
  UPDATE_FINANCEMENTS_FINDOMESTIC_CUSTOM_CALC
)

export const GET_COMPASS_DOCUMENTI_LIST = 'GET_COMPASS_DOCUMENTI_LIST'
export const getCompassDocumentiList = fetchData(GET_COMPASS_DOCUMENTI_LIST)

export const GET_COMPASS_DOCUMENTI_LIST_CALLBACK =
  'GET_COMPASS_DOCUMENTI_LIST_CALLBACK'
export const getCompassDocumentiListCallback = createBasicCreator(
  GET_COMPASS_DOCUMENTI_LIST_CALLBACK
)

export const POST_TRANSAZIONI_ADD = 'POST_TRANSAZIONI_ADD'
export const postTransazioniAdd = fetchData(POST_TRANSAZIONI_ADD)

export const POST_TRANSAZIONI_ADD_CALLBACK = 'POST_TRANSAZIONI_ADD_CALLBACK'
export const postTransazioniAddCallback = createBasicCreator(
  POST_TRANSAZIONI_ADD_CALLBACK
)

export const TRANSAZIONI_UPDATE = 'TRANSAZIONI_UPDATE'
export const transazioniUpdate = createBasicCreator(TRANSAZIONI_UPDATE)

export const POST_TRANSAZIONI_ADD_PARAMETRO = 'POST_TRANSAZIONI_ADD_PARAMETRO'
export const postTransazioniAddParametro = fetchData(
  POST_TRANSAZIONI_ADD_PARAMETRO
)

export const POST_TRANSAZIONI_ADD_PARAMETRO_CALLBACK =
  'POST_TRANSAZIONI_ADD_PARAMETRO_CALLBACK'
export const postTransazioniAddParametroCallback = createBasicCreator(
  POST_TRANSAZIONI_ADD_PARAMETRO_CALLBACK
)

// detect if email has been changed
export const REGISTRATION_EMAIL = 'REGISTRATION_EMAIL'
export const registrationEmail = createBasicCreator(REGISTRATION_EMAIL)

// proposta contrattuale
export const SEND_CONTRACT = 'SEND_CONTRACT'
export const sendContract = fetchData(SEND_CONTRACT)

// newsletter subscribe
export const SUBSCRIBE_NEWSLETTER = 'SUBSCRIBE_NEWSLETTER'
export const subscribeNewsletter = fetchData(SUBSCRIBE_NEWSLETTER)

// registration lead
export const REGISTRATION_LEAD = 'REGISTRATION_LEAD'
export const registrationLead = fetchData(REGISTRATION_LEAD)

// garanzia
export const GET_PRODUCT_WARRANTY = 'GET_PRODUCT_WARRANTY'
export const getProductWarranty = fetchData(GET_PRODUCT_WARRANTY)
export const NEW_PRODUCT_WARRANTY = 'NEW_PRODUCT_WARRANTY'
export const newProductWarranty = createBasicCreator(NEW_PRODUCT_WARRANTY)

/**
 * Load and Dump actions
 * dont touch me!
 */
export const storeRestoreInit = createBasicCreator(types.STORE_RESTORE_INIT)
export const storeRestore = fetchData(types.STORE_RESTORE)
export const storeRestoreCallBack = createBasicCreator(
  types.STORE_RESTORE_CALLBACK
)
export const storeDumpItCallBack = createBasicCreator(
  types.STORE_DUMP_IT_CALLBACK
)
export const storeDumpIt = fetchData(types.STORE_DUMP_IT)
export const storeDumpItForce = createBasicCreator(types.STORE_DUMP_IT_FORCE)
